import CreateReport from "./component";
import CreateReportContainer from "./container";

export { CreateReport, CreateReportContainer };
export default CreateReportContainer;



// WEBPACK FOOTER //
// ./client/modules/ReportForm/components/CreateReport/index.ts